/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ServiceTutelleLocaliteSearch
 */
export interface ServiceTutelleLocaliteSearch {
    /**
     * 
     * @type {number}
     * @memberof ServiceTutelleLocaliteSearch
     */
    idserviceTutelle?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServiceTutelleLocaliteSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ServiceTutelleLocaliteSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ServiceTutelleLocaliteSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServiceTutelleLocaliteSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ServiceTutelleLocaliteSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceTutelleLocaliteSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ServiceTutelleLocaliteSearch interface.
 */
export function instanceOfServiceTutelleLocaliteSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ServiceTutelleLocaliteSearchFromJSON(json: any): ServiceTutelleLocaliteSearch {
    return ServiceTutelleLocaliteSearchFromJSONTyped(json, false);
}

export function ServiceTutelleLocaliteSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceTutelleLocaliteSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idserviceTutelle': !exists(json, 'idserviceTutelle') ? undefined : json['idserviceTutelle'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ServiceTutelleLocaliteSearchToJSON(value?: ServiceTutelleLocaliteSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idserviceTutelle': value.idserviceTutelle,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

